// Tokens de design (paleta) do painel — não são dados de negócio, por isso
// ficam fora do mock de API. Períodos, meses, filiais, compradores e
// categorias são dados mockados e vêm de `DashboardV2Service.getFiltros()`.
export const BRAND = {
  laranja: '#FF5722',
  verde: '#388E3C',
  azul: '#283593',
  amarelo: '#faad14',
  vermelho: '#ff4d4f',
  preto: '#212121',
  cinza: '#7A736C',
  muted: '#9C948C',
};
